import GridController from 'react-mui-lib/grid/controller';

export default new GridController({
    entity_name: 'user',
    state_prefix: 'user_grid'
});
